import { getChatMembersCount } from '@features/components/Chat/components/ChatContent/utils';
import { CHAT_LABEL_UNKNOWN_CHAT } from '@features/components/Chat/constants';
import { Channel } from 'stream-chat';

export const ChatDetailsHeader = ({ channel }: { channel: Channel }) => {
  const { onlineCount, totalCount } = getChatMembersCount(channel);

  return (
    <div className="flex flex-col items-center pt-10 pb-4 gap-2">
      {!!channel?.data?.image && (
        <img
          src={channel.data.image}
          alt="Channel Avatar"
          width={52}
          height={52}
          className="rounded-full object-cover"
        />
      )}
      <div className="flex flex-col items-center gap-1 text-center">
        <p className="text-l-sb">{channel?.data?.name || CHAT_LABEL_UNKNOWN_CHAT}</p>
        <p className="text-m-r text-base-20">
          {totalCount} members, {onlineCount} online
        </p>
      </div>
    </div>
  );
};
